import get from 'lodash/get';
import { createSelector } from 'reselect/lib/index';

export const communityPreviewSelector = state =>
  get(state, 'communities.communityPreview');

export const communityPostsPreviewSelector = state =>
  get(state, 'communities.communityPostsPreview');

export const communityPostsListSizeSelector = state =>
  get(state, 'communities.postsList.length');

export const communityPostsPreviewListSelector = createSelector(
  communityPostsPreviewSelector,
  request => get(request, 'list', []),
);

export const sendingCommunityPreviewSelector = createSelector(
  communityPreviewSelector,
  request => get(request, 'sending', false),
);



// WEBPACK FOOTER //
// ./src/redux/communities/selectors/communityPreview.js